(function() {
    const focusableSelector = 'a, button, input, select, textarea, [tabindex]';

    function isVisibleInViewport(slide, viewportRect) {
        const slideRect = slide.getBoundingClientRect();
        if (!slideRect.width || !slideRect.height) return false;

        const horizontalIntersection = Math.min(slideRect.right, viewportRect.right) - Math.max(slideRect.left, viewportRect.left);
        const verticalIntersection = Math.min(slideRect.bottom, viewportRect.bottom) - Math.max(slideRect.top, viewportRect.top);

        return horizontalIntersection > 1 && verticalIntersection > 1;
    }

    function isVisibleSlide(slide, hasVisibleClass, viewportRect) {
        if (hasVisibleClass) {
            return slide.classList.contains('swiper-slide-visible');
        }

        if (isVisibleInViewport(slide, viewportRect)) {
            return true;
        }

        return slide.classList.contains('swiper-slide-active');
    }

    function updateCarouselAccessibility(carousel) {
        const slides = carousel.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        const hasVisibleClass = carousel.querySelector('.swiper-slide.swiper-slide-visible') !== null;
        const viewportRect = carousel.getBoundingClientRect();
        const baseSlides = carousel.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
        const totalSlides = baseSlides.length || slides.length;

        slides.forEach(function(slide) {
            const isVisible = isVisibleSlide(slide, hasVisibleClass, viewportRect);
            const logicalIndex = slide.hasAttribute('data-swiper-slide-index')
                ? parseInt(slide.getAttribute('data-swiper-slide-index'), 10) + 1
                : Array.prototype.indexOf.call(slides, slide) + 1;

            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', 'Slide ' + logicalIndex + ' of ' + totalSlides);
            slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

            slide.querySelectorAll(focusableSelector).forEach(function(focusableElement) {
                if (!isVisible) {
                    if (!focusableElement.hasAttribute('data-original-tabindex')) {
                        if (focusableElement.hasAttribute('tabindex')) {
                            focusableElement.setAttribute('data-original-tabindex', focusableElement.getAttribute('tabindex'));
                        } else {
                            focusableElement.setAttribute('data-original-tabindex', '');
                        }
                    }

                    focusableElement.setAttribute('tabindex', '-1');
                    return;
                }

                if (focusableElement.hasAttribute('data-original-tabindex')) {
                    const originalTabindex = focusableElement.getAttribute('data-original-tabindex');

                    if (originalTabindex === '') {
                        focusableElement.removeAttribute('tabindex');
                    } else {
                        focusableElement.setAttribute('tabindex', originalTabindex);
                    }

                    focusableElement.removeAttribute('data-original-tabindex');
                }
            });
        });
    }

    function updatePaginationAccessibility(carousel) {
        const carouselWrapper = carousel.closest('.carousel-wrapper');
        if (!carouselWrapper) return;

        const pagination = carouselWrapper.querySelector('.swiper-pagination');
        if (!pagination) return;

        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach(function(bullet, index) {
            bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));

            if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                bullet.setAttribute('aria-current', 'true');
            } else {
                bullet.removeAttribute('aria-current');
            }
        });
    }

    function initFeaturedCollectionCarouselA11y(root) {
        const scope = root || document;
        const carousels = scope.querySelectorAll('.carousel--featured-collection, .carousel--category-driver, .carousel--featured-product');

        carousels.forEach(function(carousel) {
            if (carousel.dataset.a11yInit === 'true') return;
            carousel.dataset.a11yInit = 'true';

            updateCarouselAccessibility(carousel);
            updatePaginationAccessibility(carousel);

            const classObserver = new MutationObserver(function(mutations) {
                const hasClassMutation = mutations.some(function(mutation) {
                    return mutation.type === 'attributes' && mutation.attributeName === 'class';
                });

                if (hasClassMutation) {
                    updateCarouselAccessibility(carousel);
                    updatePaginationAccessibility(carousel);
                }
            });

            const observeSlides = function() {
                classObserver.disconnect();
                carousel.querySelectorAll('.swiper-slide').forEach(function(slide) {
                    classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
                });
            };

            observeSlides();

            const wrapper = carousel.querySelector('.swiper-wrapper') || carousel;
            const listObserver = new MutationObserver(function() {
                observeSlides();
                updateCarouselAccessibility(carousel);
                updatePaginationAccessibility(carousel);
            });

            listObserver.observe(wrapper, { childList: true });

            const carouselWrapper = carousel.closest('.carousel-wrapper');
            const pagination = carouselWrapper ? carouselWrapper.querySelector('.swiper-pagination') : null;
            if (pagination) {
                const paginationObserver = new MutationObserver(function() {
                    updatePaginationAccessibility(carousel);
                });

                paginationObserver.observe(pagination, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            window.addEventListener('resize', function() {
                updateCarouselAccessibility(carousel);
                updatePaginationAccessibility(carousel);
            });
        });
    }

    function updateProductThumbnailAriaCurrent(thumbnailsCarousel) {
        const thumbnails = thumbnailsCarousel.querySelectorAll('.product__thumbnail-item');
        thumbnails.forEach(function(thumb) {
            if (thumb.classList.contains('swiper-slide-thumb-active')) {
                thumb.setAttribute('aria-current', 'true');
            } else {
                thumb.removeAttribute('aria-current');
            }
        });
    }

    function initProductThumbnailA11y(root) {
        const scope = root || document;
        const thumbnailsCarousels = scope.querySelectorAll('.carousel--product-thumbnails');

        thumbnailsCarousels.forEach(function(carousel) {
            if (carousel.dataset.productThumbA11yInit === 'true') return;
            carousel.dataset.productThumbA11yInit = 'true';

            updateProductThumbnailAriaCurrent(carousel);

            const classObserver = new MutationObserver(function() {
                updateProductThumbnailAriaCurrent(carousel);
            });

            carousel.querySelectorAll('.product__thumbnail-item').forEach(function(thumb) {
                classObserver.observe(thumb, { attributes: true, attributeFilter: ['class'] });
            });
        });
    }

    function applyRebuySearchRegionAttributes(root) {
        const scope = root || document;
        const rebuySearchContainers = scope.querySelectorAll('.rebuy-quick-view-dropdown__container');
        if (!rebuySearchContainers.length) return;

        rebuySearchContainers.forEach(function(container, index) {
            container.setAttribute('role', 'region');
            container.setAttribute('aria-label', 'product filter');

            container.querySelectorAll('.rebuy-quick-view__overlay[role="dialog"]').forEach(function(dialogOverlay) {
                dialogOverlay.removeAttribute('aria-labelledby');
                dialogOverlay.setAttribute('aria-label', 'Product search dialog');
                dialogOverlay.setAttribute('aria-modal', 'true');
            });

            container.querySelectorAll('.rebuy-quick-view__product').forEach(function(productCard) {
                productCard.setAttribute('role', 'group');
                productCard.setAttribute('aria-label', 'product');
            });

            container.querySelectorAll('.rebuy-quick-view__product .rebuy-product-title').forEach(function(productTitle) {
                if (productTitle.querySelector(':scope > h3.rebuy-product-title-heading')) {
                    return;
                }

                const heading = document.createElement('h3');
                heading.className = 'rebuy-product-title-heading';

                while (productTitle.firstChild) {
                    heading.appendChild(productTitle.firstChild);
                }

                productTitle.appendChild(heading);
            });

            const searchInput = container.querySelector('.rebuy-quick-view-dropdown__search-input input[type="text"]');
            if (!searchInput) return;

            const instructionsId = 'rebuy-live-filter-instructions-' + index;
            let instructions = container.querySelector('#' + instructionsId);

            if (!instructions) {
                instructions = document.createElement('span');
                instructions.id = instructionsId;
                instructions.className = 'sr-only rebuy-live-filter-instructions';
                instructions.textContent = 'The following text field filters product and collection results as you type. Enter keywords to narrow the results.';
                searchInput.parentNode.insertBefore(instructions, searchInput);
            }

            const describedBy = searchInput.getAttribute('aria-describedby');
            if (!describedBy) {
                searchInput.setAttribute('aria-describedby', instructionsId);
            } else if (describedBy.split(' ').indexOf(instructionsId) === -1) {
                searchInput.setAttribute('aria-describedby', describedBy + ' ' + instructionsId);
            }

            const statusId = 'rebuy-live-filter-status-' + index;
            let liveStatus = container.querySelector('#' + statusId);

            if (!liveStatus) {
                liveStatus = document.createElement('span');
                liveStatus.id = statusId;
                liveStatus.className = 'sr-only rebuy-live-filter-status';
                liveStatus.setAttribute('aria-live', 'assertive');
                liveStatus.setAttribute('aria-atomic', 'true');
                searchInput.parentNode.insertBefore(liveStatus, searchInput);
            }

            if (searchInput.dataset.rebuyLiveBound !== 'true') {
                searchInput.dataset.rebuyLiveBound = 'true';
                searchInput.addEventListener('input', function() {
                    scheduleRebuyLiveAnnouncement(container);
                });
            }

            if (!container.__rebuyLiveObserver) {
                container.__rebuyLiveObserver = new MutationObserver(function() {
                    normalizeRebuyTitles(container);
                    scheduleRebuyLiveAnnouncement(container);
                });

                container.__rebuyLiveObserver.observe(container, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            bindRebuySeeMoreFocus(container);
            bindRebuyFocusTrap(container);
        });
    }

    function bindRebuyFocusTrap(container) {
        if (container.dataset.rebuyFocusTrapBound === 'true') return;
        container.dataset.rebuyFocusTrapBound = 'true';

        const focusableSelector = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ].join(', ');

        function isVisible(element) {
            const style = window.getComputedStyle(element);
            return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
        }

        function isContainerVisible() {
            return container.classList.contains('visible') || (container.parentElement && container.parentElement.classList.contains('visible'));
        }

        container.addEventListener('keydown', function(event) {
            if (event.key !== 'Tab') return;
            if (!isContainerVisible()) return;

            const focusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter(isVisible);
            if (!focusableElements.length) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            const activeElement = document.activeElement;

            if (event.shiftKey) {
                if (activeElement === firstElement || !container.contains(activeElement)) {
                    event.preventDefault();
                    lastElement.focus();
                }
                return;
            }

            if (activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        });
    }

    function bindRebuySeeMoreFocus(container) {
        if (container.dataset.rebuySeeMoreBound === 'true') return;
        container.dataset.rebuySeeMoreBound = 'true';

        function handleSeeMoreActivation(seeMoreButton) {
            scheduleSeeMoreFocus(container, seeMoreButton);
        }

        container.addEventListener('click', function(event) {
            const seeMoreButton = event.target.closest('button.see-more');
            if (!seeMoreButton || !container.contains(seeMoreButton)) return;
            handleSeeMoreActivation(seeMoreButton);
        });

        container.addEventListener('keydown', function(event) {
            const seeMoreButton = event.target.closest('button.see-more');
            if (!seeMoreButton || !container.contains(seeMoreButton)) return;

            if (event.key === 'Enter' || event.key === ' ') {
                // Rebuy may handle keyboard activation without a delegated click bubbling as expected.
                // Trigger focus workflow here as well.
                window.setTimeout(function() {
                    handleSeeMoreActivation(seeMoreButton);
                }, 0);
            }
        });
    }

    function scheduleSeeMoreFocus(container, seeMoreButton) {
        function getSixthCollectionLink() {
            const currentCollectionList = container.querySelector('.rebuy-quick-view__collection-list');
            if (!currentCollectionList) return null;

            const links = currentCollectionList.querySelectorAll('.rebuy-quick-view__collection');
            return links.length > 5 ? links[5] : null;
        }

        function focusSixthCollectionLink() {
            const sixthLink = getSixthCollectionLink();
            if (sixthLink && typeof sixthLink.focus === 'function') {
                sixthLink.focus();
                return true;
            }

            return false;
        }

        if (focusSixthCollectionLink()) return;

        const seeMoreObserver = new MutationObserver(function() {
            if (focusSixthCollectionLink()) {
                seeMoreObserver.disconnect();
                window.clearTimeout(fallbackTimer);
            }
        });

        seeMoreObserver.observe(container, { childList: true, subtree: true });

        const fallbackTimer = window.setTimeout(function() {
            seeMoreObserver.disconnect();

            if (document.body.contains(seeMoreButton) && typeof seeMoreButton.focus === 'function') {
                seeMoreButton.focus();
                return;
            }

            const lastLink = container.querySelector('.rebuy-quick-view__collection-list .rebuy-quick-view__collection:last-of-type');
            if (lastLink && typeof lastLink.focus === 'function') {
                lastLink.focus();
            }
        }, 2500);
    }

    function normalizeRebuyTitles(root) {
        const scope = root || document;
        const titles = scope.querySelectorAll('p.rebuy-quick-view__title');

        titles.forEach(function(title) {
            const heading = document.createElement('h2');

            heading.className = title.className;
            heading.innerHTML = title.innerHTML;

            Array.from(title.attributes).forEach(function(attribute) {
                if (attribute.name === 'class') return;
                heading.setAttribute(attribute.name, attribute.value);
            });

            title.parentNode.replaceChild(heading, title);
        });
    }

    function getRebuyResultCount(container) {
        const productResults = container.querySelectorAll('.rebuy-quick-view__product').length;
        const collectionResults = container.querySelectorAll('.rebuy-quick-view__collection').length;
        return productResults + collectionResults;
    }

    function updateRebuyLiveAnnouncement(container) {
        const searchInput = container.querySelector('.rebuy-quick-view-dropdown__search-input input[type="text"]');
        const liveStatus = container.querySelector('.rebuy-live-filter-status');
        if (!searchInput || !liveStatus) return;

        const query = searchInput.value.trim();
        if (!query) {
            liveStatus.textContent = '';
            return;
        }

        const resultsCount = getRebuyResultCount(container);
        const message = resultsCount > 0 ? resultsCount + ' results available' : 'No results available';

        if (liveStatus.textContent !== message) {
            liveStatus.textContent = message;
        }
    }

    function scheduleRebuyLiveAnnouncement(container) {
        if (container.__rebuyLiveTimer) {
            window.clearTimeout(container.__rebuyLiveTimer);
        }

        container.__rebuyLiveTimer = window.setTimeout(function() {
            updateRebuyLiveAnnouncement(container);
        }, 120);
    }

    function initRebuySearchA11y() {
        normalizeRebuyTitles(document);
        applyRebuySearchRegionAttributes(document);

        const rebuyObserver = new MutationObserver(function(mutations) {
            const hasDomChanges = mutations.some(function(mutation) {
                return mutation.type === 'childList' && mutation.addedNodes.length > 0;
            });

            if (hasDomChanges) {
                normalizeRebuyTitles(document);
                applyRebuySearchRegionAttributes(document);
            }
        });

        rebuyObserver.observe(document.body, { childList: true, subtree: true });
    }

    function positionCookieBanner() {
        const cookieBanner = document.getElementById('onetrust-consent-sdk');
        if (!cookieBanner) return;

        const skipLink = document.querySelector('a.skip-link');
        const body = document.body;
        if (!body) return;

        if (skipLink && skipLink.parentNode === body) {
            if (skipLink.nextElementSibling !== cookieBanner) {
                body.insertBefore(cookieBanner, skipLink.nextSibling);
            }
            return;
        }

        if (body.firstElementChild !== cookieBanner) {
            body.insertBefore(cookieBanner, body.firstChild);
        }
    }

    function initCookieBannerPositioning() {
        positionCookieBanner();

        const cookieObserver = new MutationObserver(function() {
            positionCookieBanner();
        });

        cookieObserver.observe(document.body, { childList: true, subtree: false });
    }

    function wrapRebuyCartItemsWithGroup(container) {
        const scope = container || document;
        const itemsList = scope.querySelector('ul[data-smartcart-items]');
        if (!itemsList) return;

        itemsList.removeAttribute('role');

        const items = itemsList.querySelectorAll('li.rebuy-cart__flyout-item:not([data-rebuy-cart-item-a11y])');

        items.forEach(function(li) {
            li.setAttribute('data-rebuy-cart-item-a11y', 'true');
            li.removeAttribute('aria-label');

            const wrapper = document.createElement('div');
            wrapper.className = 'rebuy-cart__flyout-item-group';
            wrapper.setAttribute('role', 'group');
            wrapper.setAttribute('aria-label', 'product');

            while (li.firstChild) {
                wrapper.appendChild(li.firstChild);
            }
            li.appendChild(wrapper);
        });
    }

    function initRebuyCartItemA11y() {
        function run() {
            wrapRebuyCartItemsWithGroup(document);
        }

        run();

        const cartRoot = document.querySelector('div.rebuy-cart');
        
        if (cartRoot) {
            const observer = new MutationObserver(function(mutations) {
                const hasItemsChange = mutations.some(function(m) {
                    return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
                });
                if (hasItemsChange) {
                    run();
                }
            });
            observer.observe(cartRoot, { childList: true, subtree: true });
        }

        document.addEventListener('rebuy:smartcart.show', function() {
            run();
        });
        document.addEventListener('rebuy:smartcart.updated', function() {
            run();
        });
    }

    function initRebuyCartVisibilityA11y() {
        const TRANSITION_MS = 250;
        const cart = document.getElementById('rebuy-cart');
        if (!cart) {
            document.addEventListener('rebuy:smartcart.show', initRebuyCartVisibilityA11y, { once: true });
            return;
        }

        function updateVisibility() {
            if (cart.classList.contains('is-visible')) {
                cart.style.visibility = 'visible';
            } else {
                cart.style.visibility = 'hidden';
            }
        }

        updateVisibility();

        const observer = new MutationObserver(function(mutations) {
            const hasClassChange = mutations.some(function(m) {
                return m.type === 'attributes' && m.attributeName === 'class';
            });
            if (!hasClassChange) return;

            if (cart.classList.contains('is-visible')) {
                cart.style.visibility = 'visible';
            } else {
                setTimeout(function() {
                    cart.style.visibility = 'hidden';
                }, TRANSITION_MS);
            }
        });

        observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
    }

    function focusRebuyCartAfterRemove() {
        const firstCartItem = document.querySelector('li.rebuy-cart__flyout-item');
        if (firstCartItem) {
            if (!firstCartItem.hasAttribute('tabindex')) {
                firstCartItem.setAttribute('tabindex', '-1');
            }

            firstCartItem.focus();
            return true;
        }

        const emptyCartLink = document.querySelector('.rebuy-cart__flyout-empty-cart a');
        if (emptyCartLink) {
            emptyCartLink.focus();
            return true;
        }

        return false;
    }

    function initRebuyCartRemoveFocus() {
        let pendingRemoveFocusObserver = null;

        function disconnectObservers() {
            if (pendingRemoveFocusObserver) {
                pendingRemoveFocusObserver.disconnect();
                pendingRemoveFocusObserver = null;
            }
        }

        document.addEventListener('click', function(event) {
            const removeButton = event.target.closest('button.rebuy-cart__flyout-item-remove');
            if (!removeButton) return;

            disconnectObservers();

            // Observe the cart container (not the UL), because the UL can be removed
            // entirely when cart becomes empty.
            const cartMutationRoot = removeButton.closest('div.rebuy-cart') || document.querySelector('div.rebuy-cart') || document.body;

            pendingRemoveFocusObserver = new MutationObserver(function(mutations) {
                const hasItemMutation = mutations.some(function(mutation) {
                    return mutation.type === 'childList';
                });

                if (!hasItemMutation) return;

                setTimeout(() => {
                    if (focusRebuyCartAfterRemove()) {
                        disconnectObservers();
                    }
                }, 500);
            });

            pendingRemoveFocusObserver.observe(cartMutationRoot, { childList: true, subtree: true });
        });
    }

    function replaceShopifyPolicySpanBWithH3(root) {
        const scope = root || document;
        const policyBody = scope.querySelector('.shopify-policy__body');
        if (!policyBody) return;

        policyBody.querySelectorAll('p').forEach(function(p) {
            if (p.children.length !== 1) return;
            const span = p.firstElementChild;
            if (!span || span.tagName !== 'SPAN') return;

            const b = span.querySelector('b');
            if (!b) return;

            const firstChild = span.firstElementChild;
            const firstChildOk = span.children.length === 1 || (firstChild && firstChild.tagName === 'BR');

            if (firstChildOk) {
                const h2 = document.createElement('h2');
                h2.className = 'shopify-policy__heading';
                h2.textContent = b.textContent;
                p.parentNode.replaceChild(h2, p);
            }
        });
    }

    function initHeaderMobileDialogA11y() {
        const MOBILE_BREAKPOINT = 1079;
        const container = document.querySelector('.header__container[data-mobile-dialog-attributes]');
        if (!container) return;
        const header = container.closest('header');
        if (!header) return;

        const mobileMenuLabel = container.getAttribute('data-mobile-menu-label') || 'Mobile menu dialog';

        function updateDialogAttributes() {
            const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
            if (isMobile) {
                container.setAttribute('role', 'dialog');
                container.setAttribute('aria-modal', 'true');
                container.setAttribute('aria-label', mobileMenuLabel);
            } else {
                container.removeAttribute('role');
                container.removeAttribute('aria-modal');
                container.removeAttribute('aria-label');
            }
        }

        function getFocusableElements() {
            return Array.from(container.querySelectorAll(focusableSelector)).filter(function(el) {
                if (el.getAttribute('tabindex') === '-1') return false;
                const style = window.getComputedStyle(el);
                if (style.visibility === 'hidden' || style.display === 'none') return false;
                return true;
            });
        }

        function handleKeydown(e) {
            if (e.key !== 'Tab') return;
            if (window.innerWidth > MOBILE_BREAKPOINT) return;
            if (!header.classList.contains('js--is-open')) return;

            const focusable = getFocusableElements();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const activeEl = document.activeElement;

            if (e.shiftKey) {
                if (activeEl === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (activeEl === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        function handleFocusIn(e) {
            if (window.innerWidth > MOBILE_BREAKPOINT) return;
            if (!header.classList.contains('js--is-open')) return;
            if (container.contains(e.target)) return;

            const focusable = getFocusableElements();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const fromFirst = e.relatedTarget === first;

            setTimeout(function() {
                (fromFirst ? last : first).focus();
            }, 0);
        }

        document.addEventListener('keydown', handleKeydown, true);
        document.addEventListener('focusin', handleFocusIn, true);
        updateDialogAttributes();
        window.addEventListener('resize', updateDialogAttributes);
    }

    function replaceContactPageStrongWithH2(root) {
        const scope = root || document;
        const contentRoot = scope.querySelector('#contact-thymes-customer-service-thymes .main-page__content');
        if (!contentRoot) return;

        contentRoot.querySelectorAll('strong').forEach(function(strongElement) {
            const heading = document.createElement('h2');
            heading.innerHTML = strongElement.innerHTML;
            strongElement.parentNode.replaceChild(heading, strongElement);

            const nextSibling = heading.nextSibling;
            if (nextSibling && nextSibling.nodeName === 'BR') {
                nextSibling.parentNode.removeChild(nextSibling);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initFeaturedCollectionCarouselA11y(document);
            initProductThumbnailA11y(document);
            initRebuySearchA11y();
            initCookieBannerPositioning();
            initRebuyCartItemA11y();
            initRebuyCartVisibilityA11y();
            initRebuyCartRemoveFocus();
            initHeaderMobileDialogA11y();
            replaceContactPageStrongWithH2(document);
            replaceShopifyPolicySpanBWithH3(document);
        });
    } else {
        initFeaturedCollectionCarouselA11y(document);
        initProductThumbnailA11y(document);
        initRebuySearchA11y();
        initCookieBannerPositioning();
        initRebuyCartItemA11y();
        initRebuyCartVisibilityA11y();
        initRebuyCartRemoveFocus();
        initHeaderMobileDialogA11y();
        replaceContactPageStrongWithH2(document);
        replaceShopifyPolicySpanBWithH3(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
        initFeaturedCollectionCarouselA11y(event.target);
        initProductThumbnailA11y(event.target);
        initHeaderMobileDialogA11y();
    });
})();

/* Collection filter accordion (mobile) and dropdown toggles (desktop) */
(function initCollectionFilterDropdowns() {
    const DESKTOP_QUERY = '(min-width: 1080px)';
  
    function closeDesktopDropdowns() {
      document.querySelectorAll('.filter-group--dropdown-open').forEach((group) => {
        group.classList.remove('filter-group--dropdown-open');
        group.querySelectorAll('.js--filters__summary').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
    }
  
    function syncFilterTriggerExpandedState(group) {
      const triggers = group.querySelectorAll('.js--filters__summary');
      if (!triggers.length) return;

      const expanded = window.matchMedia(DESKTOP_QUERY).matches
        ? group.classList.contains('filter-group--dropdown-open')
        : group.hasAttribute('open');
      const value = expanded ? 'true' : 'false';
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', value));
    }
  
    document.addEventListener('click', (event) => {
      const filtersToggle = event.target.closest('.js--collection-filters-toggle');
  
      if (
        filtersToggle &&
        filtersToggle.classList.contains('js--collection-filters-toggle') &&
        window.matchMedia(DESKTOP_QUERY).matches
      ) {
        const wrapper = document.querySelector('.filters-sort__wrapper');
        if (wrapper) {
          const isVisible = wrapper.classList.toggle('filters-sort__wrapper--filters-visible');
          filtersToggle.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
          filtersToggle.classList.toggle('collection-filters-toggle--active', isVisible);
          const grid = document.querySelector('.collection-grid__container[data-collection-section-id]');
          if (grid) {
            grid.classList.toggle('collection-grid--filters-toolbar-open', isVisible);
          }
          window.dispatchEvent(new CustomEvent('collection-filters:toolbar-toggle'));
  
          if (!isVisible) {
            closeDesktopDropdowns();
          }
        }
        return;
      }
  
      const trigger = event.target.closest('.js--filters__summary');
      const filtersForm = document.querySelector('#FiltersForm');
  
      if (!filtersForm) return;
  
      if (trigger && filtersForm.contains(trigger)) {
        event.preventDefault();
        const group = trigger.closest('.js--filter');
        if (!group) return;
  
        if (window.matchMedia(DESKTOP_QUERY).matches) {
          const isOpen = group.classList.contains('filter-group--dropdown-open');
          closeDesktopDropdowns();
          if (!isOpen) {
            group.classList.add('filter-group--dropdown-open');
          }
          syncFilterTriggerExpandedState(group);
          return;
        }
  
        if (group.hasAttribute('open')) {
          group.removeAttribute('open');
        } else {
          group.setAttribute('open', '');
        }
        syncFilterTriggerExpandedState(group);
        return;
      }
  
      if (window.matchMedia(DESKTOP_QUERY).matches && !event.target.closest('.js--filter')) {
        closeDesktopDropdowns();
      }
    });
  
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      if (window.matchMedia(DESKTOP_QUERY).matches) {
        closeDesktopDropdowns();
        return;
      }
  
      const group = event.target.closest('.js--filter[open]');
      if (!group) return;
  
      group.removeAttribute('open');
      syncFilterTriggerExpandedState(group);
      group.querySelector('.js--filters__summary.filters__summary-trigger--mobile')?.focus();
    });
  
    document.querySelectorAll('#FiltersForm .js--filter').forEach(syncFilterTriggerExpandedState);
})();
  

(function initCollectionFiltersClearAll() {
    const CLEAR_WRAPPER_SELECTOR = '.collection-filters__clear-wrapper';
    const HIDDEN_CLASS = 'collection-filters__clear-wrapper--hidden';
  
    function hasActiveFilters(form) {
      if (form.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked')) {
        return true;
      }
  
      return Array.from(form.querySelectorAll('price-range input')).some((input) => input.value.trim() !== '');
    }
  
    function syncClearAllVisibility() {
      const form = document.querySelector('#FiltersForm');
      if (!form) return;

      const isActive = hasActiveFilters(form);

      document.querySelectorAll('[data-collection-filters-clear-all]').forEach((link) => {
        link.toggleAttribute('hidden', !isActive);
      });

      document.querySelectorAll(CLEAR_WRAPPER_SELECTOR).forEach((wrapper) => {
        wrapper.classList.toggle(HIDDEN_CLASS, !isActive);
        wrapper.toggleAttribute('hidden', !isActive);
      });

      document.querySelectorAll('[data-collection-active-filters-bar]').forEach((bar) => {
        bar.classList.toggle('collection-active-filters-bar--empty', !isActive);
      });

      document.querySelectorAll('[data-collection-active-filters-row]').forEach((row) => {
        row.classList.toggle('collection-active-filters-row--empty', !isActive);
      });
    }

    window.__thymesSyncClearAllVisibility = syncClearAllVisibility;

    function onFiltersFormActivity(event) {
      if (!event.target.closest('#FiltersForm')) return;
      syncClearAllVisibility();
    }
  
    function init() {
      document.addEventListener('change', onFiltersFormActivity);
      document.addEventListener('input', onFiltersFormActivity);
  
      syncClearAllVisibility();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

(function initCollectionFilterPillsAndMobileClear() {
    const DESKTOP_MQ = '(min-width: 1080px)';

    function getPillsMountDesktop() {
      return document.getElementById('CollectionActiveFilterPills');
    }

    function mergeSortIntoParams(params) {
      const sortSelect =
        document.querySelector('#SortForm select[name="sort_by"]') ||
        document.querySelector('#SortBy') ||
        document.querySelector('select[name="sort_by"]');
      if (sortSelect && sortSelect.name) {
        params.set(sortSelect.name, sortSelect.value);
      }
    }

    function paramsFromFilterForm(form) {
      const p = new URLSearchParams();
      const fd = new FormData(form);
      for (const [k, v] of fd.entries()) {
        if (v === '' || v == null) continue;
        p.append(k, v);
      }
      mergeSortIntoParams(p);
      return p;
    }

    function removeFilterParamOnce(sourceParams, paramName, paramValue) {
      const next = new URLSearchParams();
      let skipped = false;
      for (const [k, v] of sourceParams.entries()) {
        if (!skipped && k === paramName && String(v) === String(paramValue)) {
          skipped = true;
          continue;
        }
        next.append(k, v);
      }
      return next;
    }

    function buildFilterPills(form) {
      const baseUrl = new URL(window.location.href);
      const fullParams = paramsFromFilterForm(form);
      const pills = [];

      form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach((input) => {
        if (!input.name) return;
        const minus = removeFilterParamOnce(new URLSearchParams(fullParams), input.name, input.value);
        const label = input.getAttribute('data-pill-label') || input.value || '';
        pills.push({
          label,
          href: `${baseUrl.pathname}?${minus.toString()}`
        });
      });

      form.querySelectorAll('price-range').forEach((pr) => {
        const inputs = Array.from(pr.querySelectorAll('input[type="number"]')).filter(
          (el) => el.name && String(el.value || '').trim() !== ''
        );
        if (!inputs.length) return;
        const minus = new URLSearchParams(fullParams);
        inputs.forEach((el) => {
          minus.delete(el.name);
        });
        const label = pr.getAttribute('data-pill-label') || '';
        pills.push({
          label,
          href: `${baseUrl.pathname}?${minus.toString()}`
        });
      });

      return pills;
    }

    function renderPillsToMount(mount, pills) {
      if (!mount) return;

      const nextKey = pills.map(({ label, href }) => `${label}\u0000${href}`).join('\u0001');
      if (mount.dataset.pillsKey === nextKey) return;
      mount.dataset.pillsKey = nextKey;

      mount.replaceChildren();
      pills.forEach(({ label, href }) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'listitem');
        const a = document.createElement('a');
        a.className = 'collection-active-filter-pill';
        a.href = href;
        const text = document.createElement('span');
        text.className = 'collection-active-filter-pill__text';
        text.textContent = label;
        const removeMark = document.createElement('span');
        removeMark.className = 'collection-active-filter-pill__remove';
        removeMark.setAttribute('aria-hidden', 'true');
        removeMark.textContent = '\u00d7';
        a.appendChild(text);
        a.appendChild(removeMark);
        li.appendChild(a);
        mount.appendChild(li);
      });
    }

    function syncFilterGroupSelectedCounts() {
      const form = document.querySelector('#FiltersForm');
      if (!form) return;

      form.querySelectorAll('.js--filter').forEach((group) => {
        const checkedCount = group.querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        ).length;
        const hasPrice = Array.from(group.querySelectorAll('input[type="number"]')).some((el) =>
          String(el.value || '').trim() !== ''
        );
        const count = checkedCount > 0 ? checkedCount : hasPrice ? 1 : 0;

        group.querySelectorAll('.js--filters__selected').forEach((span) => {
          const nextText = count > 0 ? `(${count})` : '(0)';
          const shouldHide = count === 0;

          if (span.textContent !== nextText) {
            span.textContent = nextText;
          }
          if (shouldHide && !span.classList.contains('hidden')) {
            span.classList.add('hidden');
          } else if (!shouldHide && span.classList.contains('hidden')) {
            span.classList.remove('hidden');
          }
        });
      });
    }

    function syncCollectionFilterPills() {
      const form = document.querySelector('#FiltersForm');
      if (!form) return;

      const pills = buildFilterPills(form);
      const isDesktop = window.matchMedia(DESKTOP_MQ).matches;

      if (isDesktop) {
        const mount = getPillsMountDesktop();
        const grid = document.querySelector('.collection-grid__container[data-filter-display]');
        const displayMode = grid?.dataset?.filterDisplay || '';
        const compactToolbarOpen = Boolean(grid?.classList.contains('collection-grid--filters-toolbar-open'));

        if (displayMode === 'compact_toggle' && !compactToolbarOpen) {
          renderPillsToMount(mount, []);
        } else {
          renderPillsToMount(mount, pills);
        }

        renderPillsToMount(document.getElementById('CollectionActiveFilterPillsMobilePage'), []);
        renderPillsToMount(document.getElementById('CollectionActiveFilterPillsMobileModal'), []);
      } else {
        renderPillsToMount(getPillsMountDesktop(), []);
        renderPillsToMount(document.getElementById('CollectionActiveFilterPillsMobilePage'), pills);
        renderPillsToMount(document.getElementById('CollectionActiveFilterPillsMobileModal'), pills);
      }
    }

    function syncAll() {
      syncFilterGroupSelectedCounts();
      syncCollectionFilterPills();
      window.__thymesSyncClearAllVisibility?.();
    }

    window.__thymesCollectionFiltersSyncUi = syncAll;

    function onFilterFormActivity(event) {
      if (event.target.closest('#FiltersForm')) {
        syncAll();
      }
    }

    function onSortFormChange(event) {
      const sel = event.target.closest('#SortForm select[name="sort_by"], #SortFormMobile select[name="sort_by"]');
      if (sel) {
        syncAll();
      }
    }

    function attachFilterFetchSyncObservers() {
      document.querySelectorAll('#ProductCount').forEach((el) => {
        if (el.dataset.thymesFetchObserved === 'true') return;
        el.dataset.thymesFetchObserved = 'true';

        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.attributeName !== 'class') continue;
            if (!mutation.target.classList.contains('loading')) {
              syncAll();
              break;
            }
          }
        });
        observer.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }

    function init() {
      document.addEventListener('change', onFilterFormActivity);
      document.addEventListener('input', onFilterFormActivity);
      document.addEventListener('change', onSortFormChange);
      document.addEventListener('collection-filters:toolbar-toggle', syncAll);

      window.addEventListener('popstate', syncAll);
      document.addEventListener('shopify:section:load', () => {
        attachFilterFetchSyncObservers();
        syncAll();
      });

      attachFilterFetchSyncObservers();

      try {
        window.matchMedia(DESKTOP_MQ).addEventListener('change', syncAll);
      } catch (e) {
        window.matchMedia(DESKTOP_MQ).addListener(syncAll);
      }

      syncAll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* Mobile collection filter drawer slide animation */
  (function initCollectionFilterDrawerAnimation() {
    const MOBILE_QUERY = '(max-width: 1079px)';
    const MODAL_SELECTOR = '.collection-filters-sort-modal';
    const OPEN_CLASS = 'modal--open';
    const CLOSING_CLASS = 'collection-filters-sort-modal--closing';
    const NO_SCROLL_CLASS = 'noscroll';
    const DRAWER_DURATION_MS = 220;
  
    function isMobileDrawerContext() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }
  
    function getOpenDrawerModal() {
      return document.querySelector(`${MODAL_SELECTOR}.${OPEN_CLASS}`);
    }
  
    function finalizeDrawerClose(modal) {
      modal.classList.remove(CLOSING_CLASS);
      modal.querySelectorAll('[tabindex="0"]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      document.body.classList.remove(NO_SCROLL_CLASS);
      const targetId = modal.id.replace('modal_', '');
      const trigger = document.querySelector(`[data-modal-target="${targetId}"]`);
      trigger?.focus();
      window.dispatchEvent(new CustomEvent('close.modal', { detail: modal }));
    }
  
    function closeCollectionFilterDrawer(modal) {
      if (!modal || modal.classList.contains(CLOSING_CLASS)) return;
  
      modal.classList.add(CLOSING_CLASS);
      modal.classList.remove(OPEN_CLASS);
      window.setTimeout(() => finalizeDrawerClose(modal), DRAWER_DURATION_MS);
    }
  
    document.addEventListener(
      'click',
      (event) => {
        if (!isMobileDrawerContext()) return;
  
        const closeTarget = event.target.closest(
          `${MODAL_SELECTOR} .modal__close-button, ${MODAL_SELECTOR} .modal__overlay`
        );
        if (!closeTarget) return;
  
        const modal = closeTarget.closest(MODAL_SELECTOR);
        if (!modal?.classList.contains(OPEN_CLASS)) return;
  
        event.preventDefault();
        event.stopImmediatePropagation();
        closeCollectionFilterDrawer(modal);
      },
      true
    );
  
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape' || !isMobileDrawerContext()) return;
  
        const modal = getOpenDrawerModal();
        if (!modal) return;
  
        event.preventDefault();
        event.stopImmediatePropagation();
        closeCollectionFilterDrawer(modal);
      },
      true
    );

    function collapseMobileFilterGroups() {
      if (!isMobileDrawerContext()) return;

      document.querySelectorAll('#FiltersForm .js--filter[open]').forEach((group) => {
        group.removeAttribute('open');
        group.querySelectorAll('.js--filters__summary').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    document.addEventListener(
      'click',
      (event) => {
        if (!isMobileDrawerContext()) return;

        const trigger = event.target.closest(
          '.filters-sort-trigger.modal__trigger[data-modal-target^="filters-sort-"]'
        );
        if (!trigger) return;

        const targetId = trigger.getAttribute('data-modal-target');
        if (!targetId) return;

        const modal = document.getElementById('modal_' + targetId);
        if (!modal?.classList.contains('collection-filters-sort-modal')) return;

        if (modal.classList.contains(OPEN_CLASS) || modal.classList.contains(CLOSING_CLASS)) {
          return;
        }

        event.preventDefault();
        collapseMobileFilterGroups();
        document.body.classList.add(NO_SCROLL_CLASS);
        modal.classList.add(OPEN_CLASS);
        window.__thymesCollectionFiltersSyncUi?.();
      },
      false
    );

    window.__thymesCloseCollectionFilterDrawer = closeCollectionFilterDrawer;
  })();

(function initCollectionFilterSectionFetch() {
  function getCollectionSectionId() {
    return document.querySelector('.collection-grid__container[data-collection-section-id]')?.dataset
      ?.collectionSectionId;
  }

  function isInCollectionGrid(anchor) {
    return Boolean(anchor.closest('.collection-grid__container[data-collection-section-id]'));
  }

  function resyncFilterGroupAriaAfterSectionSwap() {
    const DESKTOP_QUERY = '(min-width: 1080px)';
    document.querySelectorAll('#FiltersForm .js--filter').forEach((group) => {
      const triggers = group.querySelectorAll('.js--filters__summary');
      if (!triggers.length) return;
      const expanded = window.matchMedia(DESKTOP_QUERY).matches
        ? group.classList.contains('filter-group--dropdown-open')
        : group.hasAttribute('open');
      const value = expanded ? 'true' : 'false';
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', value));
    });
  }

  function fetchCollectionSectionHtml(href, sectionId) {
    const target = new URL(href, window.location.origin);
    if (target.origin !== window.location.origin) {
      return Promise.reject(new Error('origin'));
    }
    const fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('sections', sectionId);
    return fetch(fetchUrl.toString())
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((data) => {
        const html = data[sectionId];
        if (!html || typeof html !== 'string') {
          throw new Error('missing section html');
        }
        const displayUrl = new URL(target.href);
        displayUrl.searchParams.delete('sections');
        return { html, displayUrl };
      });
  }

  function getParsedSectionRoot(html, sectionId) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (
      doc.getElementById('shopify-section-' + sectionId) ||
      doc.querySelector('.shopify-section') ||
      doc.body
    );
  }

  function replaceFromIncomingRoot(incomingRoot, selector) {
    const incoming = incomingRoot.querySelector(selector);
    const cur = document.querySelector(selector);
    if (incoming && cur) {
      cur.replaceWith(document.importNode(incoming, true));
      return true;
    }
    return false;
  }

  function replaceFiltersFormWrapper(incomingRoot, formSelector) {
    const currentForm = document.querySelector(formSelector);
    const incomingForm = incomingRoot.querySelector(formSelector);
    if (!currentForm || !incomingForm) return false;

    const currentWrapper = currentForm.closest('filters-form');
    const incomingWrapper = incomingForm.closest('filters-form');
    if (!currentWrapper || !incomingWrapper) return false;

    currentWrapper.replaceWith(document.importNode(incomingWrapper, true));
    return true;
  }

  function syncProductCountsFromIncomingSection(incomingRoot, sectionId) {
    const sectionMount = document.getElementById('shopify-section-' + sectionId);
    if (!sectionMount) return;

    const incomingCounts = incomingRoot.querySelectorAll('.product-count');
    const currentCounts = sectionMount.querySelectorAll('.product-count');
    const len = Math.min(incomingCounts.length, currentCounts.length);
    for (let i = 0; i < len; i++) {
      currentCounts[i].replaceWith(document.importNode(incomingCounts[i], true));
    }
  }

  function afterCollectionDomUpdate(sectionId, displayUrl) {
    history.pushState({}, '', displayUrl.pathname + displayUrl.search + displayUrl.hash);

    window.__thymesCollectionFiltersSyncUi?.();
    window.__thymesSyncClearAllVisibility?.();

    document.getElementById('shopify-section-' + sectionId)?.dispatchEvent(
      new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } })
    );

    resyncFilterGroupAriaAfterSectionSwap();
  }

  function applyPartialCollectionFilterUpdate(html, sectionId, displayUrl, options) {
    const preserveMobileDrawer = Boolean(options && options.preserveMobileDrawer);
    const incomingRoot = getParsedSectionRoot(html, sectionId);

    replaceFromIncomingRoot(incomingRoot, '#ProductGridContainer');
    replaceFiltersFormWrapper(incomingRoot, '#FiltersForm');
    replaceFiltersFormWrapper(incomingRoot, '#SortForm');
    replaceFiltersFormWrapper(incomingRoot, '#SortFormMobile');
    replaceFromIncomingRoot(incomingRoot, '[data-collection-active-filters-row]');

    const incomingBars = incomingRoot.querySelectorAll('[data-collection-active-filters-bar]');
    const currentBars = document.querySelectorAll('[data-collection-active-filters-bar]');
    incomingBars.forEach((incomingBar, index) => {
      const currentBar = currentBars[index];
      if (currentBar) {
        currentBar.replaceWith(document.importNode(incomingBar, true));
      }
    });

    syncProductCountsFromIncomingSection(incomingRoot, sectionId);

    afterCollectionDomUpdate(sectionId, displayUrl);

    if (preserveMobileDrawer) {
      const modal = document.querySelector('.collection-filters-sort-modal');
      if (modal) {
        modal.classList.remove('collection-filters-sort-modal--closing');
        modal.classList.add('modal--open');
        document.body.classList.add('noscroll');
      }
    }
  }

  function applyPartialFilterNavigation(href, options) {
    const sectionId = getCollectionSectionId();
    if (!sectionId) {
      window.location.assign(href);
      return;
    }

    fetchCollectionSectionHtml(href, sectionId)
      .then(({ html, displayUrl }) => {
        applyPartialCollectionFilterUpdate(html, sectionId, displayUrl, options);
      })
      .catch(() => {
        window.location.assign(href);
      });
  }

  function applyCollectionFilterNavigation(href) {
    const sectionId = getCollectionSectionId();

    if (!sectionId) {
      window.location.assign(href);
      return;
    }

    fetchCollectionSectionHtml(href, sectionId)
      .then(({ html, displayUrl }) => {
        const mountId = 'shopify-section-' + sectionId;
        const current = document.getElementById(mountId);
        if (!current) {
          throw new Error('missing section mount');
        }

        const gridBefore = current.querySelector('.collection-grid__container[data-filter-display]');
        const wasCompactToolbarOpen =
          gridBefore?.dataset.filterDisplay === 'compact_toggle' &&
          gridBefore.classList.contains('collection-grid--filters-toolbar-open');

        current.outerHTML = html.trim();

        if (wasCompactToolbarOpen) {
          const sectionRoot = document.getElementById(mountId);
          const newGrid = sectionRoot?.querySelector('.collection-grid__container[data-filter-display]');
          if (newGrid?.dataset.filterDisplay === 'compact_toggle') {
            newGrid.classList.add('collection-grid--filters-toolbar-open');
            document.querySelector('.filters-sort__wrapper')?.classList.add('filters-sort__wrapper--filters-visible');
            const toggle = document.querySelector('.js--collection-filters-toggle');
            if (toggle) {
              toggle.setAttribute('aria-expanded', 'true');
              toggle.classList.add('collection-filters-toggle--active');
            }
          }
        }

        afterCollectionDomUpdate(sectionId, displayUrl);
      })
      .catch(() => {
        window.location.assign(href);
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest('a');
      if (!anchor || !anchor.href) return;

      const isPill = anchor.classList.contains('collection-active-filter-pill');
      const isGroupClear = anchor.classList.contains('filter-group__clear--mobile-drawer');
      const isClearAll =
        anchor.classList.contains('collection-filters__clear') ||
        anchor.hasAttribute('data-collection-filters-clear-all');
      if (!isPill && !isGroupClear && !isClearAll) return;

      if (!isInCollectionGrid(anchor)) return;

      event.preventDefault();

      const isMobile = window.matchMedia('(max-width: 1079px)').matches;
      const preserveMobileDrawer = isMobile && Boolean(anchor.closest('.collection-filters-sort-modal'));

      if (isMobile && (isPill || isGroupClear || isClearAll)) {
        applyPartialFilterNavigation(anchor.href, { preserveMobileDrawer });
        return;
      }

      applyCollectionFilterNavigation(anchor.href);
    },
    true
  );
})();
  